export default __webpack_public_path__ + "static/assets/med_gel_solid_03_f_mask.2453a0c7.png";